import { Typography } from '@pwskills/rachnaui';
import { classNames } from '@pwskills/rachnaui/utils';
import React from 'react';

type Props = {
  wrapperClass?: string;
  headingClass?: string;
  subTitleClass?: string;
  title: string;
  subtitle?: string;
  isSeo?: boolean;
};

const ProfessionalThemeHeader = ({
  wrapperClass,
  headingClass,
  subTitleClass,
  title,
  subtitle,
  isSeo,
}: Props) => {
  return (
    <div className={wrapperClass || 'flex flex-col gap-3 medium:gap-6'}>
      <div className="flex justify-start items-center gap-x-6">
        <div className="w-2 bg-orange-500 py-[26px]" />
        <Typography component={isSeo ? 'h1' : 'h3'} variant="bold" className={headingClass || ''}>
          {title}
        </Typography>
      </div>
      {subtitle && (
        <Typography
          component="body-small"
          variant="regular"
          className={classNames('text-gray-650 large:!w-[737px]', subTitleClass || '')}
        >
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default ProfessionalThemeHeader;
